import { getMenuViewportReference } from 'bento-ordering/menus/utils/index';

/**
 * A util that takes in an array of menu label references and split it into
 * two separate arrays of menu sections where the rendered menu section bar width
 * no longer exceed the rendered width of the view port width.
 * @param {*} marginOffset the value passed in to determine the smallest value before recalculating sections
 * @param {*} storeSectionItemWidths an array containing the value of the widths of each menu section
 * @param {*} menuSections menu section objects
 */
export const getSectionLabelsForMenuBarAndDropdown = (
  marginOffset,
  menuSections,
  storeSectionItemWidths
) => {
  const allowableWidth = getMenuViewportReference().clientWidth - marginOffset;

  const menuSectionItemsGroupedIntoViewableGroups = [];
  const moreDropdownMenuSectionItems = [];

  let sectionBarWidthSoFar = 0;
  Array.isArray(menuSections) &&
    menuSections.forEach((section, index) => {
      const currentSectionItemWidth = storeSectionItemWidths[index];
      sectionBarWidthSoFar += currentSectionItemWidth;

      if (sectionBarWidthSoFar >= allowableWidth) {
        moreDropdownMenuSectionItems.push(section);
      }
    });

  function doMoreMenuSectionsRemain(index, count) {
    return index + 1 < count;
  }

  sectionBarWidthSoFar = 0;
  menuSectionItemsGroupedIntoViewableGroups.push([]);
  let groupIndex = 0;
  Array.isArray(menuSections) &&
    menuSections.forEach((section, index) => {
      const currentSectionItemWidth = storeSectionItemWidths[index];
      sectionBarWidthSoFar += currentSectionItemWidth;

      if (sectionBarWidthSoFar < allowableWidth) {
        menuSectionItemsGroupedIntoViewableGroups[groupIndex].push(section);
      } else {
        menuSectionItemsGroupedIntoViewableGroups.push([section]);
        if (doMoreMenuSectionsRemain(index, menuSections.length)) {
          sectionBarWidthSoFar = currentSectionItemWidth;
          groupIndex += 1;
        }
      }
    });

  return {
    menuSectionItemsGroupedIntoViewableGroups,
    moreDropdownMenuSectionItems
  };
};
